<a
  href="https://www.fashiongo.net/thepinksoul/sign-up?referralMethod=WIDGET&referralMethodSub=BUTTON"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Fashion Go - Pink Soul Store"
  style="text-decoration: none; display: block; width: 360px; margin: auto"
>
  <table
    style="
      width: 100%;
      border: 0;
      border-spacing: 0;
      border-collapse: collapse;
      margin: 0px auto;
      padding: 0px;
      font-size: medium;
      font-style: normal;
      font-variant-ligatures: normal;
      font-variant-caps: normal;
      font-weight: 400;
      letter-spacing: normal;
      orphans: 2;
      text-align: start;
      text-transform: none;
      white-space: normal;
      widows: 2;
      word-spacing: 0px;
      -webkit-text-stroke-width: 0px;
      text-decoration-thickness: initial;
      text-decoration-style: initial;
      text-decoration-color: initial;
      color: rgb(51, 51, 51);
      font-family: Arial;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;
      box-shadow: 3px 4px 4px 0px #6666661c;
    "
  >
    <tbody style="border: 0">
      <tr style="margin: 0; padding: 0; border: 0">
        <td
          style="
            margin: 0;
            padding: 0;
            width: 75px;
            background-color: #333;
            text-align: center;
            vertical-align: middle;
            border: 0;
          "
        >
          <img
            src="https://d2njprwt6vp5kv.cloudfront.net/referral/widget/img/logo_btn_widget.svg"
            alt="FG"
            style="width: 44px; height: 24px; vertical-align: middle"
          />
        </td>
        <td
          style="
            width: 24px;
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
            vertical-align: middle;
            border: 0;
          "
        ></td>
        <td
          style="
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
            height: 80px;
            vertical-align: middle;
            border: 0;
          "
        >
          <table
            style="
              border: 0;
              border-spacing: 0;
              border-collapse: collapse;
              table-layout: fixed;
              vertical-align: middle;
              box-shadow: none;
            "
          >
            <tbody style="border: 0">
              <tr style="margin: 0; padding: 0; border: 0">
                <td
                  style="
                    margin: 0;
                    padding: 0;
                    font-family: Georgia;
                    font-size: 18px;
                    line-height: 24px;
                    border: 0;
                  "
                >
                  Get $100 Off Today
                </td>
              </tr>
              <tr style="margin: 0; padding: 0; border: 0">
                <td
                  style="
                    margin: 0;
                    padding: 0;
                    font-family: Arial;
                    font-size: 14px;
                    line-height: 22px;
                    border: 0;
                  "
                >
                  Shop Wholesale on FASHIONGO
                </td>
              </tr>
            </tbody>
          </table>
        </td>
        <td
          style="
            width: 8px;
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
            vertical-align: middle;
            border: 0;
          "
        ></td>
        <td
          style="
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
            width: 10px;
            text-align: center;
            vertical-align: middle;
            border: 0;
          "
        >
          <img
            src="https://d2njprwt6vp5kv.cloudfront.net/referral/widget/img/icon_arr_btn_widget.svg"
            alt=""
            style="width: 10px; height: 18px; vertical-align: middle; border: 0"
          />
        </td>
        <td
          style="
            width: 28px;
            margin: 0;
            padding: 0;
            background-color: #f7f7f7;
            vertical-align: middle;
            border: 0;
          "
        ></td>
      </tr>
    </tbody>
  </table>
</a>
